import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  OnInit,
  QueryList,
  ViewChildren,
} from '@angular/core';
import {ToastMessage, ToastService} from '@app/global-message/toasts/toast.service';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {I18nModule} from '@spartacus/core';

@UntilDestroy()
@Component({
  selector: 'dcp-toasts',
  imports: [I18nModule],
  templateUrl: './toasts.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ToastsComponent implements OnInit, AfterViewInit {
  toasts: ToastMessage[] = [];
  @ViewChildren('toastEl') toastElements: QueryList<ElementRef<HTMLElement>>;

  constructor(
    public toastService: ToastService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.toastService
      .getToast()
      .pipe(untilDestroyed(this))
      .subscribe((toast: ToastMessage) => {
        this.toasts.push(toast);
        setTimeout(() => {
          this.toasts = this.toasts.filter((e) => e !== toast);
        }, toast.opts.duration);
        this.cdr.detectChanges();
      });
  }

  ngAfterViewInit(): void {
    // double rAF wait for UI5 to move <udex-toast> to <body> before opening it (fixes flaky visibility)
    this.toastElements.changes.pipe(untilDestroyed(this)).subscribe(() =>
      requestAnimationFrame(() =>
        requestAnimationFrame(() => {
          this.toastElements.forEach((toast) => ((toast.nativeElement as any).open = true));
        }),
      ),
    );
  }
}
